import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlayCircle, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';

const VIDEO_SRC = '/demo/carekids-demo.mp4';
const WEBM_SRC = '/demo/carekids-demo.webm';
const POSTER_SRC = '/demo/carekids-demo-poster.jpg';

export const DemoVideoButton = ({ className = '', label = 'Watch the Demo', testId = 'watch-demo-btn', variant = 'outline', autoOpen = false }) => {
  const [open, setOpen] = useState(autoOpen);
  const navigate = useNavigate();

  const startTrial = () => {
    setOpen(false);
    navigate('/pricing');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Button variant={variant} className={className} onClick={() => setOpen(true)} data-testid={testId}>
        <PlayCircle className="mr-2 w-5 h-5" />
        {label}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-5xl w-[95vw] p-0 overflow-hidden bg-neutral-950 border-neutral-800 gap-0" data-testid="demo-video-modal">
          <DialogTitle className="sr-only">CareKids WI product demo</DialogTitle>
          <DialogDescription className="sr-only">A narrated tour of CareKids WI</DialogDescription>
          {open && (
            <video
              poster={POSTER_SRC}
              controls
              autoPlay
              playsInline
              className="w-full aspect-video bg-black"
              data-testid="demo-video-player"
            >
              <source src={VIDEO_SRC} type="video/mp4" />
              <source src={WEBM_SRC} type="video/webm" />
            </video>
          )}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 px-5 py-4 bg-neutral-900 text-white">
            <div>
              <p className="font-heading font-bold">Like what you see?</p>
              <p className="text-sm text-neutral-400">7-day free trial · Cancel anytime</p>
            </div>
            <Button className="btn-primary" onClick={startTrial} data-testid="demo-video-start-trial-btn">
              Start free trial
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
